"use strict";

var map;
var markers = [];
var userMarker;
var geocoder;
var src = "https://services.shiner.co.uk/dealers?type=jsonp";
var countries = 'detect';
var storeCode = document.querySelector('.section__store-finder').dataset.storeCode;
var brands = storeCode;
var groups = '';
function initialize() {
  var options = {
    zoom: 2,
    panControl: false,
    zoomControl: true,
    scaleControl: true,
    streetViewControl: false,
    mapTypeControl: false,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    mapId: 'dealers'
  };
  map = new google.maps.Map(document.getElementById('google_map'), options);
  geocoder = new google.maps.Geocoder();

  // Define north-east and south-west points of UK
  var ne = new google.maps.LatLng(57.00, 2.00);
  var sw = new google.maps.LatLng(51.00, -6.00);
  var bounds = new google.maps.LatLngBounds(sw, ne);
  map.fitBounds(bounds);
  if (false && navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(currentLocationSuccess, currentLocationError);
  }
  $('#countrySelect option').each(function () {
    groups += (groups ? '|' : '') + $(this).val();
  });
  getJSONP();
}
initialize();
function currentLocationSuccess(position) {
  var lat = position.coords.latitude;
  var lng = position.coords.longitude;
  var latlng = new google.maps.LatLng(lat, lng);
  geocoder.geocode({
    'latLng': latlng
  }, function (results, status) {
    if (status == google.maps.GeocoderStatus.OK) {
      var country = getCountry(results);
      if (country) {
        setCountry(country);
      }
    }
  });
}
;
function getJSONP() {
  var script = document.createElement('script');
  script.src = src + '&brands=' + brands + '&country=' + countries + '&groups=' + groups;
  document.getElementsByTagName('head')[0].appendChild(script);
}
function callbackJSONP(data) {
  var data = JSON.parse(data);
  var bounds = new google.maps.LatLngBounds();
  var offline = data.offline;
  var infowindow = new google.maps.InfoWindow();
  var marker, i;
  for (var i = 0; i < markers.length; i++) {
    markers[i].setMap(null);
  }
  for (i = 0; i < offline.length; i++) {
    var point = new google.maps.LatLng(offline[i].lat, offline[i].lng);
    marker = new google.maps.marker.AdvancedMarkerElement({
      map: map,
      position: point
    });
    markers.push(marker);
    google.maps.event.addListener(marker, 'click', function (marker, i) {
      return function () {
        infowindow.setContent(offline[i].name + '<p>' + offline[i].address);
        infowindow.open(map, marker);
      };
    }(marker, i));
    bounds.extend(point);
  }
  if (!userMarker) {
    if (i > 1) {
      map.fitBounds(bounds);
    } else {
      map.setCenter(point);
      map.setZoom(14);
    }
  }
  var online = data.online;
  var html = '';
  for (i = 0; i < online.length; i++) {
    html = html + '<li>' + online[i].name + ' (' + online[i].url + ')</li>';
  }
  if (document.getElementById('online_list')) {
    document.getElementById('online_list').innerHTML = html;
  }
  if (data.detected) {
    $('#countrySelect').val(data.detected);
  }
  var countries = data.countries;
  var select = document.getElementById('countrySelect');
  if (countries && select) {
    for (i = 0; i < select.length; i++) {
      var valid = false;
      var option = select[i];
      if (option.value == '') {
        valid = true;
      }
      var values = option.value.split(',');
      for (var j = 0; j < values.length; j++) {
        if (countries[values[j]]) {
          valid = true;
          break;
        }
      }
      if (!valid) {
        option.setAttribute('hidden', 'hidden');
      } else {
        option.removeAttribute('hidden');
      }
    }
  }
}
function getCountry(results) {
  var country;
  if (results[0]) {
    for (var i = 0; i < results[0].address_components.length; i++) {
      if (results[0].address_components[i].types[0] == "country") {
        country = results[0].address_components[i].short_name;
      }
    }
  }
  if (country) {
    country = country.toLowerCase();
  }
  return country;
}
function setCountry(country, change) {
  change = change ? change : false;
  var match = $('#countrySelect option[value*="' + country + '"]:first');
  if ($(match).length > 0) {
    if (!$(match).is(':selected')) {
      $(match).parent().val($(match).val()).change();
    }
  } else {
    if ($('#countrySelect').val() != '' || change == true) {
      $('#countrySelect').val('').change();
    } else {
      $('#countrySelect').val('');
    }
  }
}
$(document).ready(function () {
  $('#findLocation').click(function () {
    var address = $('#userLocation').val();
    var locationPin = document.createElement('div');
    locationPin.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="#232323" width="40px" height="40px" viewBox="0 0 56 56"><path d="M 28.0117 52.8203 C 28.9492 52.8203 30.1679 49.0703 30.1679 42.1328 L 30.1679 20.5703 C 33.9883 19.6094 36.8008 16.1406 36.8008 12.0156 C 36.8008 7.1641 32.8867 3.1797 28.0117 3.1797 C 23.1133 3.1797 19.1992 7.1641 19.1992 12.0156 C 19.1992 16.1172 22.0117 19.5859 25.8086 20.5703 L 25.8086 42.1328 C 25.8086 49.0469 27.0508 52.8203 28.0117 52.8203 Z M 25.4805 12.5078 C 23.8867 12.5078 22.4805 11.1016 22.4805 9.4609 C 22.4805 7.8437 23.8867 6.4609 25.4805 6.4609 C 27.1445 6.4609 28.4805 7.8437 28.4805 9.4609 C 28.4805 11.1016 27.1445 12.5078 25.4805 12.5078 Z"/></svg>';
    geocoder.geocode({
      'address': address
    }, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        var country = getCountry(results);
        if (country) {
          setCountry(country);
        }
        map.setCenter(results[0].geometry.location);
        map.setZoom(9);
        if (userMarker) {
          userMarker.setMap(null);
          userMarker = null;
        }
        $('#userLocation').css('background-color', '#fff');
        userMarker = new google.maps.marker.AdvancedMarkerElement({
          map: map,
          position: results[0].geometry.location,
          content: locationPin
        });
      } else {
        $('#userLocation').css('background-color', '#fdd');
      }
    });
  });
  $("#userLocation").keyup(function (event) {
    if (event.keyCode == 13) {
      $("#findLocation").click();
    }
  });
  $('#countrySelect').change(function () {
    countries = $(this).val();
    if (userMarker) {
      userMarker.setMap(null);
      userMarker = null;
    }
    getJSONP();
  });
});